export default function theSafeHomeDirective() {
  return {
    template: require('./home.html'),
    controller: 'TheSafeHomeController',
    controllerAs: 'theSafeHomeVM',
    bindToController: true,
    replace: true,
  };
}
